import React from 'react'
import { Spinner, View } from 'oio-react'
import PropTypes from 'prop-types'
import { useParams } from 'react-router-dom'
import PageContext from 'src/apps/Page/libraries/context'
import PageVisualEditor from 'src/apps/Page/pages/VisualEditor'
import { usePage } from 'src/graphql/hooks'

const ContentPageVisualEditor = ({ returnUrl }) => {
   const { pageSlug } = useParams()
   const { page, loading: pageIsLoading } = usePage({ slug: pageSlug, withContent: true })

   if (pageIsLoading) {
      return (
         <View
            display="flex"
            justifyContent="center"
            alignItems="center"
            float="left"
            width="100%"
            height="100%"
            backgroundColor="#222">
            <Spinner width="48px" height="48px" color="#666" />
         </View>
      )
   }

   return (
      <PageContext.Provider value={page}>
         <PageVisualEditor returnUrl={returnUrl} />
      </PageContext.Provider>
   )
}

ContentPageVisualEditor.propTypes = {
   returnUrl: PropTypes.string.isRequired
}

export default ContentPageVisualEditor
